/**
 * Persisted UI-preference helpers (sidebar mode/side) backed by
 * localStorage, plus a re-export of the theme helpers. Single import site for
 * settings persistence — extracted from the former SettingsDialog modal.
 */
export type SidebarMode = 'auto' | 'collapsed' | 'hamburger';
// Which edge the sidebar drawer (and, on mobile, its bottom-nav "More" trigger)
// anchor to. A right anchor improves one-handed reachability on large phones.
export type SidebarSide = 'left' | 'right';

// Re-export theme helpers so importers have one place for persisted UI prefs.
export { applyTheme, getTheme, type ThemeMode } from '@/lib/theme';

const STORAGE_KEY = 'trf_sidebar_mode';
const VALID_MODES: SidebarMode[] = ['auto', 'collapsed', 'hamburger'];
const SIDEBAR_SIDE_KEY = 'trf_sidebar_side';
const VALID_SIDES: SidebarSide[] = ['left', 'right'];

export function getSidebarMode(): SidebarMode {
  const stored = localStorage.getItem(STORAGE_KEY);
  return VALID_MODES.includes(stored as SidebarMode) ? (stored as SidebarMode) : 'auto';
}

export function setSidebarModeStorage(mode: SidebarMode): void {
  localStorage.setItem(STORAGE_KEY, mode);
}

export function getSidebarSide(): SidebarSide {
  const stored = localStorage.getItem(SIDEBAR_SIDE_KEY);
  return VALID_SIDES.includes(stored as SidebarSide) ? (stored as SidebarSide) : 'left';
}

export function setSidebarSideStorage(side: SidebarSide): void {
  localStorage.setItem(SIDEBAR_SIDE_KEY, side);
}

// The chat-mode preference (tabs / split / choice) retired with the voice
// modes it selected (#1731 phase 3, F-10): the call floats over the thread as
// the PiP. The old `trf_chat_mode` key is simply no longer read.
